module.exports = __webpack_public_path__ + "media/想要了解成都.41adb9b2.mp4";